import * as types from 'subapps/kb/actions'

const defaultState = {
  isLoading: false,
}

const reducers = {}

reducers[types.FETCH_AVAILABILITY_REQUEST] = state => {
  return {
    ...state,
    isLoading: true,
  }
}

reducers[types.FETCH_AVAILABILITY_SUCCESS] = (state, action) => {
  const { key, available, value } = action.data

  return {
    ...state,
    [key]: available,
    value,
    isLoading: false,
  }
}

reducers[types.FETCH_AVAILABILITY_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isLoading: false,
    error: err,
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
